import toxir from "../img/toxir.jpg";
import umida from "../img/umida.jpg";
import malika from "../img/malika.jpg";
import jek from "../img/jek.jpg";

const twitts = [
  {
    id: 1,
    name: "jek",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: jek,
    like: false,
  },
  {
    id: 2,
    name: "toxir",
    comment: "I have got a black Bugatti Chiyron",
    img: toxir,
    like: false,
  },
  {
    id: 3,
    name: "malika",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: malika,
    like: false,
  },
  {
    id: 4,
    name: "umida",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: umida,
    like: false,
  },
  {
    id: 5,
    name: "toxir",
    comment: "Lets goooo...!",
    img: toxir,
    like: false,
  },
  {
    id: 6,
    name: "jek",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: jek,
    like: false,
  },
  {
    id: 7,
    name: "umida",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: umida,
    like: false,
  },
  {
    id: 8,
    name: "malika",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: malika,
    like: false,
  },
  {
    id: 9,
    name: "toxir",
    comment: "Tugadi :)",
    img: toxir,
    like: false,
  },
  {
    id: 10,
    name: "umida",
    comment:
      " Bugatti has added the Pur Sport model to the Chiron lineup for 2021. ",
    img: umida,
    like: false,
  },
];

export default twitts;
